/**
 *
 * @param {object, undefined} user
 */
export function formatUserName(user, withSuffix = false) {
    let userName = '';

    if (user?.first_name) {
        userName += user.first_name;
    }

    if (user?.last_name) {
        if (userName !== '') {
            userName += ' ';
        }
        userName += user.last_name;
    }

    if (withSuffix && user?.name_suffix) {
        if (userName !== '') {
            userName += ', ';
        }
        userName += user.name_suffix;
    }

    return userName;
}
